const signup = {
  advantages: {
    title: 'Don’t have an account yet?',
    subtitle: 'Stay well-informed with relevant health tips and personalized offers for you:',
    steps: {
      1: {
        title: 'Exclusive offers',
        text: 'from your local pharmacy',
      },
      2: {
        title: 'Current health topics',
        text: 'and trends',
      },
      3: {
        title: 'Attractive coupons',
        text: 'and manufacturer discounts',
      },
      4: {
        title: 'Personal recommendations',
        text: 'for your health',
      },
      5: {
        title: 'my life as a free e-paper',
        text: '- stay well-informed about all relevant health topics',
      },
    },
  },
}

export default signup